// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"67d14a40","1156":"71b31f5d","1741":"139fa2f4","2131":"d0072553","2382":"7f609c2d","6122":"8264c76f","8134":"a7ae370b"}[chunkId] + ".css";
};